import { useContext, useEffect, useState } from 'react';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';
import useService from '../useService';

const useVpaDetails = () => {
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [vpaDetailsIsCollapsed, setVpaDetailsIsCollapsed] = useState<boolean>(true);
	const [dataFetchComplete, setDataFetchComplete] = useState<boolean>(false);
	const [vpaDetails, setVpaDetails] = useState<any>([]);
	const [showLoader, setShowLoader] = useState<boolean>(false);
	const { showAlert } = useContext(AppContext);
	const { getBankOrVpaDetails } = useService();
	const [dataListKey, setDataListKey] = useState<number>(0);

	const fetchRowData = async () => {
		try {
			setShowLoader(true);
			const fetchedData = await getBankOrVpaDetails(true, false);
			setVpaDetails({ rowCount: fetchedData.rowCount, data: fetchedData.data });
		} catch (error: any) {
			showAlert(_get(error, 'error', 'Error while fetching data'), { type: 'error' });
		} finally {
			setShowLoader(false);
			setDataFetchComplete(true);
		}
	};

	useEffect(() => {
		if (!vpaDetailsIsCollapsed && !dataFetchComplete) {
			fetchRowData();
		}
	}, [vpaDetailsIsCollapsed]);

	const handleDatalistFetchData = () => {
		return vpaDetails;
	};

	const turnForceUpdateOff = () => {
		setForceUpdate(false);
	};

	const triggerRefresh = () => {
		if (!vpaDetailsIsCollapsed) {
			setForceUpdate(true);
		}
	};

	const updateDetails = (listData: any[]) => {
		setVpaDetails({ rowCount: listData.length, data: listData });
		setDataFetchComplete(true);
		setDataListKey((prev) => prev + 1);
	};

	return {
		vpaDetailsIsCollapsed,
		setVpaDetailsIsCollapsed,
		showLoader,
		handleDatalistFetchData,
		triggerRefresh,
		turnForceUpdateOff,
		forceUpdate,
		dataFetchComplete,
		updateDetails,
		dataListKey
	};
};

export default useVpaDetails;
